module.exports = __webpack_public_path__ + "img/img14.4d2fad4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/06/img14.png
// module id = 254
// module chunks = 0